import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { IAggregateBusinessRepository } from '@/coreInfrastructureModule/interfaces/IAggregateBusinessRepository';
import { IError } from '@/coreInfrastructureModule/interfaces/IError';

/**
 * 取引先番号を取得するユースケース
 * @param business - 取引情報
 */
export class GetBusinessNumberUseCase {
  private repository: IAggregateBusinessRepository;

  /**
   * コンストラクタ
   * @param repository - リポジトリ
   */
  constructor(repository: IAggregateBusinessRepository) {
    this.repository = repository;
  }
  /**
   * 取引先番号を取得する
   * @param businessName - 取引先名
   */
  async execute(businessName: string): Promise<INetworkResult<string | undefined, IError>> {
    try {
      const result = await this.repository.getBusinessNumber(businessName);
      return result;
    } catch (error) {
      console.error(error);
      return {
        status: {
          type: 'error',
          error: {
            message: '想定外のエラーが発生しました',
            statusCode: 0,
            code: '',
          },
        },
      };
    }
  }
}
